import { render, staticRenderFns } from "./StopWatchHistorico.vue?vue&type=template&id=74e537c7&scoped=true"
import script from "./StopWatchHistorico.vue?vue&type=script&lang=js"
export * from "./StopWatchHistorico.vue?vue&type=script&lang=js"
import style0 from "./StopWatchHistorico.vue?vue&type=style&index=0&id=74e537c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e537c7",
  null
  
)

export default component.exports